import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { ThemeProvider } from './theme/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import  Aboutsection from './components/AboutSection';
import Highlights from './components/Highlights';
import Statistics from './components/Statistics';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Demo from './components/Demo';
import Form from './components/form';
import SectionDivider from './components/SectionDivider';
import styled from 'styled-components';
import { FaRocket } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
 
 
// New page imports
import Tutorial from './pages/Tutorial';
import Support from './pages/Support';
import Features from './components/Features';
import Pricing from './pages/Pricing';
import About from './pages/About';
import JobScheduling from './pages/features/JobScheduling';
import Dispatch from './pages/features/Dispatch';
import Invoicing from './pages/features/Invoicing';
import Payments from './pages/features/Payments.js';
import CustomerManagement from './pages/features/CustomerManagement';
import Blog from './pages/resources/Blog';
import HelpCenter from './pages/resources/HelpCenter';
import HelpCenterIOS from './pages/resources/HelpCenterIOS';
import ApiDocumentation from './pages/resources/ApiDocumentation';
import PartnerProgram from './pages/resources/PartnerProgram';
import AboutUs from './pages/company/AboutUs';
import Careers from './pages/company/Careers';
import Press from './pages/company/Press';
import FreeTrial from './pages/FreeTrial';
import SmartTimesheets from './pages/features/SmartTimesheets';
import Ecosystem from './pages/features/Ecosystem';
import AndMore from './pages/features/AndMore';
import AndMoreIndustries from './pages/industries/AndMoreIndustries';
import BlogPost from './pages/resources/BlogPost';
import TermsOfService from './pages/legal/TermsOfService.js';
import PrivacyPolicy from './pages/legal/PrivacyPolicy.js';
import PaymentTerms from './pages/legal/PaymentTerms.js';
import ResponseToLawEnforcement from './pages/legal/ResponseToLawEnforcement.js';
import FeaturesAlt from './components/FeaturesAlt';
import TitledCards from './components/TitledCards';
import Beta from './pages/Beta';
import Helpdesk from './pages/Helpdesk';
import GettingStarted from './pages/resources/ios/GettingStarted';
import Troubleshooting from './pages/resources/ios/Troubleshooting';
import FAQ from './pages/resources/ios/FAQ';
import FaqSection from './components/FaqSection';
import Insightsection from './components/InsightSection';
import TestimonialSlider from './components/TestimonialSlider';
import Affiliate from './pages/company/Affiliate'

//industriespage
import Hvac from './pages/industries/HVAC';
import Plumbinglp from './pages/industries/Plumbing';
import Cleaninglp from './pages/industries/Cleaning';
import Electricalp from './pages/industries/ElectricalService';
import FireProtectionlp from './pages/industries/FireProtection';
import SecuritySafetylp from './pages/industries/SecuritySafety';
import WindowCleaninglp from './pages/industries/WindowCleaning';
import LocksmithServicelp from './pages/industries/LocksmithService';
import ApplianceRepairlp from './pages/industries/ApplianceRepair';
import TreeCarelp from './pages/industries/TreeCare';
import LawnCarelp from './pages/industries/LawnCare';
import Handymanlp from './pages/industries/Handyman';
import Constructionlp from './pages/industries/Construction';
import PropertyStructurallp from './pages/industries/PropertyStructural';
import JunkRemovallp from './pages/industries/JunkRemoval';
import PestControllp from './pages/industries/PestControl';
import Itlp from './pages/industries/It';
import AutoGaslp from './pages/industries/AutoGas';
import Technicallp from './pages/industries/Technical';
import CleaningMaintenancelp from './pages/industries/CleaningMaintenance';
import GarageDoorlp from './pages/industries/GarageDoor';
import CarpetCleaninglp from './pages/industries/CarpetCleaning';
import ResidentialCleaninglp from './pages/industries/ResidentialCleaning';
import PostConstructionlp from './pages/industries/PostConstruction';
import AlarmSmartlp from './pages/industries/AlarmSmart';
import PressureWashinglp from './pages/industries/PressureWashing';
import Specialitylp from './pages/industries/Speciality';
import Landscapinglp from './pages/industries/Landscaping';
import SnowRemovallp from './pages/industries/SnowRemoval';
import Paintinglp from './pages/industries/Painting';
import Roofinglp from './pages/industries/Roofing';
import PoolSpalp from './pages/industries/PoolSpa';
import andmoreindustries from './pages/industries/AndMoreIndustries';
 
 
 
// import app.css
 
//font family
import "@fontsource/poppins/300.css"; // Only weight 300
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
 
 
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
 
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text.primary};
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
 
  ::selection {
    background: ${props => props.theme.colors.primary}20;
    color: ${props => props.theme.colors.primary};
  }
 
  ::-webkit-scrollbar {
    width: 8px;
  }
 
  ::-webkit-scrollbar-track {
    background: transparent;
  }
 
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.text.secondary}20;
    border-radius: ${props => props.theme.borderRadius.full};
  }
 
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.text.secondary}40;
  }
`;
 
const MainContent = styled.div`
  // No margin-top needed anymore since banner is gone
`;
 
// Create a wrapper component to handle the conditional rendering
const AppContent = () => {
  const location = useLocation();
  const isBetaPage = location.pathname === '/beta';
 
  const defaultDescription = "ServTrackr - Field Service Management Software for HVAC, Plumbing, Electrical, Cleaning, and more. Streamline operations with smart scheduling, dispatch, invoicing, and customer management.";
  const defaultImageUrl = "https://servtrackr.com/servtrackrbanner.png"; // Placeholder - replace with your actual default image URL
  const baseUrl = "https://servtrackr.com"; // Replace with your actual domain
 
  return (
    <>
      <Helmet
        titleTemplate="%s | ServTrackr"
        defaultTitle="ServTrackr - Field Service Management Software"
      >
        <meta name="description" content={defaultDescription} />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}${location.pathname}${location.search}`} />
        <meta property="og:title" content="ServTrackr - Field Service Management Software" />
        <meta property="og:description" content={defaultDescription} />
        <meta property="og:image" content={defaultImageUrl} />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={`${baseUrl}${location.pathname}${location.search}`} />
        <meta name="twitter:title" content="ServTrackr - Field Service Management Software" />
        <meta name="twitter:description" content={defaultDescription} />
        <meta name="twitter:image" content={defaultImageUrl} />
        {/* Add more tags as needed */}
      </Helmet>
      {!isBetaPage && <Navbar scrolled={false} />}
      <MainContent>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Aboutsection />

            </>
          } />
          <Route path="/features" element={<Features />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/support" element={<Support />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/features/job-scheduling" element={<JobScheduling />} />
          <Route path="/features/dispatch" element={<Dispatch />} />
          <Route path="/features/invoicing" element={<Invoicing />} />
          <Route path="/features/payments" element={<Payments />} />
          <Route path="/features/customer-management" element={<CustomerManagement />} />
          <Route path="/features/smart-timesheets" element={<SmartTimesheets />} />
          
          <Route path="/resources/blog" element={<Blog />} />
          <Route path="/resources/help-center" element={<HelpCenter />} />
          <Route path="/resources/help-center/ios" element={<HelpCenterIOS />} />
          <Route path="/resources/help-center/ios/getting-started" element={<GettingStarted />} />
          <Route path="/resources/help-center/ios/features" element={<Features />} />
          <Route path="/resources/help-center/ios/troubleshooting" element={<Troubleshooting />} />
          <Route path="/resources/help-center/ios/faq" element={<FAQ />} />
          <Route path="/resources/api-documentation" element={<ApiDocumentation />} />
          <Route path="/resources/partner-program" element={<PartnerProgram />} />
          <Route path="/company/about-us" element={<AboutUs />} />
          <Route path="/company/careers" element={<Careers />} />
          <Route path="/company/contact" element={<Contact />} />
          <Route path="/company/press" element={<Press />} />
          <Route path="/free-trial" element={<FreeTrial />} />
          <Route path="/helpdesk" element={<Helpdesk />} />
          <Route path="/features/ecosystem" element={<Ecosystem />} />
          <Route path="/features/and-more" element={<AndMore />} />
          <Route path="/resources/blog/:slug" element={<BlogPost />} />
          <Route path="/legal/terms-of-service" element={<TermsOfService />} />
          <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal/payment-terms" element={<PaymentTerms />} />
          <Route path="/legal/law-enforcement-response" element={<ResponseToLawEnforcement />} />
          <Route path="/beta" element={<Beta />} />
          <Route path="/industries/hvac" element={<Hvac />} />
          <Route path="/industries/plumbing" element={<Plumbinglp/>} />
          <Route path="/industries/cleaning" element={<Cleaninglp/>} />
          <Route path="/industries/electrical" element={<Electricalp/>} />
          <Route path="/industries/fire-protecttion" element={<FireProtectionlp/>} />
          <Route path="/industries/security-safety" element={<SecuritySafetylp/>} />
          <Route path="/industries/window-cleaning" element={<WindowCleaninglp/>} />
          <Route path="/industries/locksmith-service" element={<LocksmithServicelp/>} />
          <Route path="/industries/appliance-repair" element={<ApplianceRepairlp/>} />
          <Route path="/industries/tree-care" element={<TreeCarelp/>} />
          <Route path="/industries/lawn-care" element={<LawnCarelp/>} />
          <Route path="/industries/handyman" element={<Handymanlp/>} />
          <Route path="/industries/construction" element={<Constructionlp/>} />
          <Route path="/industries/property-structural" element={<PropertyStructurallp/>} />
          <Route path="/industries/junk-removal" element={<JunkRemovallp/>} />
          <Route path="/industries/pest-control" element={<PestControllp/>} />
          <Route path="/industries/it" element={<Itlp/>} />
          <Route path="/industries/auto-gas" element={<AutoGaslp/>} />
          <Route path="/industries/technical" element={<Technicallp/>} />
          <Route path="/industries/cleaning-maintenance" element={<CleaningMaintenancelp/>} />
          <Route path="/industries/garage-door" element={<GarageDoorlp/>} />
          <Route path="/industries/carpet-cleaning" element={<CarpetCleaninglp/>} />
          <Route path="/industries/residential-cleaning" element={<ResidentialCleaninglp/>} />
          <Route path="/industries/post-construction" element={<PostConstructionlp/>} />
          <Route path="/industries/alarm-smart" element={<AlarmSmartlp/>} />
          <Route path="/industries/pressure-washing" element={<PressureWashinglp/>} />
          <Route path="/industries/speciality" element={<Specialitylp/>} />
          <Route path="/industries/landscaping" element={<Landscapinglp/>} />
          <Route path="/industries/snow-removal" element={<SnowRemovallp/>} />
          <Route path="/industries/painting" element={<Paintinglp/>} />
          <Route path="/industries/roofing" element={<Roofinglp/>} />
          <Route path="/industries/pool-spa" element={<PoolSpalp/>} /> 
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/industries/and-more" element={<AndMoreIndustries />} />
          
         
         
   
           
        </Routes>
      </MainContent>
      {!isBetaPage && <Footer />}
    </>
  );
};
 
function App() {
  return (
    <Router>
      <ThemeProvider>
        <GlobalStyle />
        <AppContent />
      </ThemeProvider>
    </Router>
  );
}
 
 
 
export default App;